import Card from "@material-ui/core/Card";
import Container from "@saleor/components/Container";
import OrderFilterBar from "@saleor/components/OrderFilterBar";
import OrderList from "@saleor/motherOrders/components/OrderList";
import {
  createFilterStructure,
  OrderFilterKeys,
  OrderListFilterOpts
} from "@saleor/motherOrders/components/OrderListPage/filters";
import { MotherOrderList_orders_edges_node } from "@saleor/motherOrders/types/MotherOrderList";
import {
  masterFulfillmentPath,
  OrderListUrlSortField
} from "@saleor/motherOrders/urls";
import { FilterPageProps, PageListProps, SortPage } from "@saleor/types";
import {
  DeliveryTypeEnum,
  SmopOrderStatusEnum
} from "@saleor/types/globalTypes";
import {
  canManageFulfillment,
  canViewAllMalls
} from "@saleor/utils/handlers/userHandler";
import React from "react";
import { useIntl } from "react-intl";

import MasterFulfillmentPageHeader from "../MasterFulfillmentPageHeader";

export interface MasterFulfillmentPageProps
  extends PageListProps,
    FilterPageProps<OrderFilterKeys, OrderListFilterOpts>,
    SortPage<OrderListUrlSortField> {
  orders: MotherOrderList_orders_edges_node[];
  activeTab;
  queryVariables;
  generateShippingDialog: (orderId: string) => void;
  onAddRemarks: (
    orderId: string,
    orderCode: string,
    orderOldRemarks?: string,
    orderOldRemarkId?: string
  ) => void;
  onAssignRider: (orderId: string, orderCode: string, mallId: string) => void;
  onOverrideStatus: (
    orderId: string,
    orderStatus: SmopOrderStatusEnum,
    newOrderStatus: SmopOrderStatusEnum,
    courier?: string
  ) => void;
  onUpdateStatus: (
    orderId: string,
    orderStatus: SmopOrderStatusEnum,
    newOrderStatus: SmopOrderStatusEnum,
    courier?: string
  ) => void;
  onCancelStatus: (courier: string, orderId: string) => void;
  download?: any;
  onGrabStatusRefresh?: (orderId: string) => void;
  onPandaGoStatusRefresh?: (orderId: string) => void;
  refetchOrders;
  optionsDelTypes: any;
  selectedDelTypes: string[];
  activeDelType: string;
  onClickedOpenDelTypesModal: (delTypes: string[]) => void;
  onActiveDelType: (delType: string) => void;
}

const MasterFulfillmentPage: React.FC<MasterFulfillmentPageProps> = ({
  refetchOrders,
  activeTab,
  currencySymbol,
  currentTab,
  initialSearch,
  filterOpts,
  queryVariables,
  tabs,
  onAdd,
  onAll,
  onSearchChange,
  onFilterChange,
  onTabChange,
  onTabDelete,
  onTabSave,
  generateShippingDialog,
  onAssignRider,
  onAddRemarks,
  onOverrideStatus,
  onUpdateStatus,
  onCancelStatus,
  download,
  onGrabStatusRefresh,
  onPandaGoStatusRefresh,
  optionsDelTypes,
  selectedDelTypes,
  activeDelType,
  onClickedOpenDelTypesModal,
  onActiveDelType,
  ...listProps
}) => {
  const intl = useIntl();

  const disableMallActions = !canViewAllMalls();
  const disableOderActions = !canManageFulfillment();

  const forExclusions = () => {
    if (activeDelType === "" && disableMallActions) {
      return [OrderFilterKeys.mall];
    } else if (activeDelType !== "" && disableMallActions) {
      return [OrderFilterKeys.mall, OrderFilterKeys.deliveryType];
    } else if (activeDelType !== "" && !disableMallActions) {
      return [OrderFilterKeys.deliveryType];
    } else {
      return null;
    }
  };

  const specifyDelTypeOptions = () => {
    if (selectedDelTypes && selectedDelTypes.length > 0) {
      const selectedDeliveryTypes: DeliveryTypeEnum[] = selectedDelTypes.map(
        type => DeliveryTypeEnum[type as keyof typeof DeliveryTypeEnum]
      );

      return selectedDeliveryTypes;
    } else {
      return null;
    }
  };

  const filterStructure = createFilterStructure(
    intl,
    filterOpts,
    forExclusions(),
    specifyDelTypeOptions()
  );

  return (
    <Container>
      <MasterFulfillmentPageHeader
        optionsDelTypes={optionsDelTypes}
        selectedDelTypes={selectedDelTypes}
        activeDelType={activeDelType}
        onClickedOpenDelTypesModal={onClickedOpenDelTypesModal}
        onActiveDelType={onActiveDelType}
      />

      <Card>
        <OrderFilterBar
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          initialSearch={initialSearch}
          onAll={onAll}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
          tabs={tabs}
          isDownloadVisible={false}
          isAllAtStart={true}
          allTabLabel={intl.formatMessage({
            defaultMessage: "All",
            description: "tab name"
          })}
          filterStructure={filterStructure}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search"
          })}
          queryVariables={queryVariables}
          activeTab={""}
        />

        <OrderList
          {...listProps}
          generateShippingDialog={generateShippingDialog}
          onAssignRider={onAssignRider}
          onAddRemarks={onAddRemarks}
          onOverrideStatus={onOverrideStatus}
          onUpdateStatus={onUpdateStatus}
          onCancelStatus={onCancelStatus}
          onGrabStatusRefresh={onGrabStatusRefresh}
          onPandaGoStatusRefresh={onPandaGoStatusRefresh}
          refetchOrders={refetchOrders}
          disableAction={disableOderActions}
          detailsPath={masterFulfillmentPath}
          includedColumns={[
            "Order Status",
            "Brands",
            "Order Date",
            "Mother Order",
            activeDelType === "" ? "Delivery" : "",
            "3PL Status",
            "Aging",
            disableMallActions ? "" : "Mall",
            "Payment",
            "Customer",
            "Rider Name",
            "Remarks"
          ]}
        />
      </Card>
    </Container>
  );
};
MasterFulfillmentPage.displayName = "MasterFulfillmentPage";
export default MasterFulfillmentPage;
